import {
  navigationSquadBuilderIcon,
  navigationTacticsIcon,
} from "@/components/organisms/NavigationBar/NavBarTouchDevice/components/NavIcons";
import { GAME_NAME } from "@/config/game";
import { MetaRatingIcon } from "@/icons";
import { useTranslation } from "@repo/shared/i18n";
import { useLocation, useNavigate } from "react-router";

import { BaseLandingPage } from "./BaseLandingPage/BaseLandingPage";
import { USPType } from "./BaseLandingPage/USP";

export const SquadBuilderLandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["landing", "common"]);

  const USPs: USPType[] = [
    {
      icon: <MetaRatingIcon />,
      title: t("squadBuilder.usp.metaSquads.title"),
      description: (
        <div className="w-76 mobile:w-100">
          {t("squadBuilder.usp.metaSquads.description")}
        </div>
      ),
    },
    {
      icon: <div className="size-6">{navigationSquadBuilderIcon}</div>,
      title: t("squadBuilder.usp.uniqueSquads.title"),
      description: (
        <div className="w-76 mobile:w-100">
          {t("squadBuilder.usp.uniqueSquads.description")}
        </div>
      ),
    },
    {
      icon: <div className="size-6">{navigationTacticsIcon}</div>,
      title: t("squadBuilder.usp.premiumTactics.title"),
      description: (
        <div className="w-76 mobile:w-100">
          {t("squadBuilder.usp.premiumTactics.description")}
        </div>
      ),
    },
  ];

  return (
    <BaseLandingPage
      heroTitle={t("squadBuilder.heroTitle", { game: GAME_NAME })}
      pageTitle={t("squadBuilder.pageTitle")}
      ctaTitle={t("common:promo.subscribeNow")}
      USPs={USPs}
      onHandleCTA={() => {
        navigate("/subscription");
      }}
      videoTitle={t("squadBuilder.videoTitle")}
      videoDescription={t("squadBuilder.videoDescription")}
    >
      {null}
    </BaseLandingPage>
  );
};
